/* eslint-disable radix */

import {
  AD_COMPARER_INIT_CAMPAIGN_TOTAL,
  AD_COMPARER_UPDATE_TOTAL
} from '../constants/ActionTypes';

const initialState = {
  FirstAds: {
    qcProcess: {
      LINK_CLICKS: {
        totalAds: 0,
        totalQC: 0
      },
      VIDEO_VIEWS: {
        totalAds: 0,
        totalQC: 0
      },
      LEAD_GENERATION: {
        totalAds: 0,
        totalQC: 0
      },
      PRODUCT_CATALOG_SALES: {
        totalAds: 0,
        totalQC: 0
      },
      CONVERSIONS: {
        totalAds: 0,
        totalQC: 0
      }
    },
    generalQCProgress: 0
  },
  SecondAds: {
    qcProcess: {
      LINK_CLICKS: {
        totalAds: 0,
        totalQC: 0
      },
      VIDEO_VIEWS: {
        totalAds: 0,
        totalQC: 0
      },
      LEAD_GENERATION: {
        totalAds: 0,
        totalQC: 0
      },
      PRODUCT_CATALOG_SALES: {
        totalAds: 0,
        totalQC: 0
      },
      CONVERSIONS: {
        totalAds: 0,
        totalQC: 0
      }
    },
    generalQCProgress: 0
  }
};

const run = {};

run[AD_COMPARER_INIT_CAMPAIGN_TOTAL] = (state, action) =>
  Object.assign({}, state, {
    [`${action.key}Ads`]: {
      generalQCProgress: 0,
      qcProcess: action.campaigns
    }
  });

run[AD_COMPARER_UPDATE_TOTAL] = (state, action) =>
  Object.assign({}, state, {
    [`${action.key}Ads`]: {
      qcProcess: action.campaigns,
      generalQCProgress: parseInt(action.generalQCProgress)
    }
  });

const adComparerReducer = (state = initialState, action) => {
  if (action.type in run) {
    return run[action.type](state, action);
  }

  return state;
};

export default adComparerReducer;



// WEBPACK FOOTER //
// ./src/reducers/ad.comparer.js